/*
 * - SABBANG PAHAYA GAMANEEYAN -
 * Created on Mon Jan 30 2023 5:03:00 AM
 *
 * By Kapila Rathnayaka
 *
 * Copyright (c) 2023 Kayble Zone Private Limited - Colombo Sri Lanka
 * Contact : http://www.kayblezone.lk - kapilarathnayaka@outlook.com
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import BreadCrumbProvider from "./context/BreadCrumbProvider";
import reducers from "./reducers";
import "./index.css";
import { XMLDataContextControllerProvider } from "./context/index";
import App from "./App";
import { PageTitleProvider } from "./context/PageTitleContext";

const store = createStore(reducers, compose(applyMiddleware(thunk)));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <PageTitleProvider>
    <BreadCrumbProvider>
    <XMLDataContextControllerProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </XMLDataContextControllerProvider>
    </BreadCrumbProvider>
  </PageTitleProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
